import React from "react";
import Carousel from "./Carousel";
import { Box } from "@mui/material";
import LicenseInfo from "./LicenseInfo";

const SERVICES = [
  { key: "decks", title: "Decks" },
  { key: "windows", title: "Window Replacements" },
  { key: "remodels", title: "Remodels" },
  { key: "basements", title: "Basements" },
  { key: "other", title: "Other Services" }
];

// Images are now loaded directly from public/full-gallery/[service]/
const LOCAL_GALLERIES = {
  decks: [
    "/full-gallery/decks/decks001.avif",
    "/full-gallery/decks/decks002.avif",
    "/full-gallery/decks/decks003.avif",
    "/full-gallery/decks/decks004.avif",
    "/full-gallery/decks/decks005.avif",
    "/full-gallery/decks/decks006.avif",
    "/full-gallery/decks/decks007.avif",
    "/full-gallery/decks/decks008.avif",
    "/full-gallery/decks/decks009.avif",
  ],
  windows: [
    "/full-gallery/windows/windows001.avif",
    "/full-gallery/windows/windows002.avif",
    "/full-gallery/windows/windows003.avif",
    "/full-gallery/windows/windows004.avif",
  ],
  remodels: [
    "/full-gallery/remodels/remodels001.avif",
    "/full-gallery/remodels/remodels002.avif",
    "/full-gallery/remodels/remodels003.avif",
    "/full-gallery/remodels/remodels004.avif",
  ],
  basements: [
    "/full-gallery/basements/basements001.avif",
    "/full-gallery/basements/basements002.avif",
    "/full-gallery/basements/basements003.avif",
  ],
  other: [
    "/full-gallery/other/other001.avif",
    "/full-gallery/other/other002.avif",
  ],
};

const Gallery = () => {
  return (
    <Box display="flex" flexDirection="column" gap={4} mt="5%">
      {SERVICES.map(({ key, title }) => {
        const images = LOCAL_GALLERIES[key] || [];
        return (
          <Box key={key}>
            <Carousel images={images} title={title} />
          </Box>
        );
      })}
      <LicenseInfo />
    </Box>
  );
};

export default Gallery;